import { PassportFilesResource } from '@backend/resources/student-document'
import { ApiStudentRequest, request } from '../utils'

export type RawGetPassportFileResponse = {
  data: PassportFilesResource
}

export async function getPassportFile(passportId?: string) {
  return request<RawGetPassportFileResponse>(
    new ApiStudentRequest(`/documents/passports/${passportId}/file`, {
      method: 'GET',
    }),
    {
      isExpectedResponse: (res): res is RawGetPassportFileResponse => res as boolean,
    },
  )
}
